export const mandatoryFields = [
  'active',
  'licensing_required',
  'enable_auto_release',
  'outlet_name',
  'original_name',
  'languages',
  'media_subtype',
  'article_count',
  'id',
  'outlet_url',
  'frequency',
  'feeds_info',
  'description',
  'publisher_id',
  'licensing_agency_id',
  'outlet_provider_id',
  'carma_ocr_provider',
  'mozrank',
  'reviewed',
  'autoremove_manual_content',
  'smart_summary'
]

const locationFields        = [ 'global_region_id', 'country_code', 'state', 'address', 'city' ]
const classificationFields   = [ 'scope_type', 'outlet_sector_id', 'outlet_category_id', 'priority_level', 'quality_assurance_date' ]
const mediaFields           = [ 'channel', 'genres', 'airtime']
const aliasesFields         = [ 'name_aliases', 'url_aliases', 'nla_alias', 'media_track_english_alias', 'media_track_portuguese_alias', 'media_track_asian_alias', 'media_track_arabic_alias', 'media_track_french_alias', 'media_track_iran_alias', 'media_track_hebrew_alias', 'media_track_broadcast_alias','tveyes_alias','tveyes_podcast_alias']
const paywallFields         = [ 'paywall_option', 'original_paywall_cost', 'original_currency','payment_interval',
  'paywall_cost_in_usd','last_cost_checked_date','paywall_remarks',
  'active_subscription', 'subscription_expire_date', 'access_office_id',
  'login_data', 'projects',  'paywall_e_edition' ]

export const typeResolver = {
  print: {
    mediaSubTypes: ['newspaper', 'magazine'],
    forms : [
      {
        title: 'location',
        fields: locationFields
      },
      {
        title: 'classification',
        fields: classificationFields
      },
      {
        title: 'aliases',
        fields: aliasesFields
      }
    ]
  },
  broadcast: {
    mediaSubTypes: ['tv', 'radio', 'podcast'],
    forms: [
      {
        title: 'location',
        fields: locationFields
      },
      {
        title: 'classification',
        fields: classificationFields
      },
      {
        title: 'broadcast',
        fields: mediaFields
      },
      {
        title: 'aliases',
        fields: aliasesFields
      }
    ]
  },
  online: {
    mediaSubTypes: ['website', 'news', 'blog', 'forum'],
    forms: [
      {
        title: 'location',
        fields: locationFields
      },
      {
        title: 'classification',
        fields: classificationFields
      },
      {
        title: 'paywall',
        fields: paywallFields
      },
      {
        title: 'aliases',
        fields: aliasesFields
      }
    ]
  },
  social: {
    mediaSubTypes: [ 'social-networks' ],
    forms: [
      {
        title: 'location',
        fields: locationFields
      },
      {
        title: 'classification',
        fields: classificationFields
      },
      {
        title: 'paywall',
        fields: paywallFields
      },
      {
        title: 'aliases',
        fields: aliasesFields
      }
    ]
  }
}

// generate input fields for const.js file
function generateAliasInput(key) {
  const isSelect = ['name_aliases', 'url_aliases'].includes(key)

  let input = {
    type: isSelect ? 'select' : 'input',
    translate_label: `outlets.form.${key}`,
    id: `${key}`,
    name: `${key}`,
    style: 'width: 23.5%;'
  }
  
  if (!['url_aliases'].includes(key)) {
     input.validate = [ 'no_leading_or_trailing_spaces' ];
  }

  if(isSelect) {
    input = { ...input, ...{
        placeholder: "Add alias",
        translateTagPlaceholder: 'outlets.form.add_alias',
        translateNoOptions: 'outlets.form.add_alias',
        dropdownDirection: 'bottom',
        customClass: 'keywords',
        taggable: true,
        options: [],
        searchable: true,
        hideSelected: true,
        multiple: true,
        allowEmpty: true,
        preselectFirst: false,
        showNoResults: false,
      }
    }
  }
  return input
}

export const aliasInputFields = aliasesFields.reduce((acc, key) => {
  acc[key] = generateAliasInput(key)
  return acc
}, {})

export const mediaTypes = [
  {
    label: 'Newspaper',
    value: 'newspaper',
    type: 'print'
  },
  {
    label: 'Magazine',
    value: 'magazine',
    type: 'print'
  },

  {
    label: 'Tv',
    value: 'tv',
    type: 'broadcast'

  },
  {
    label: 'Radio',
    value: 'radio',
  },
  {
    label: 'Podcast',
    value: 'podcast',
    type: 'broadcast'

  },

  {
    label: 'Website',
    value: 'website',
    type: 'online'
  },
  {
    label: 'News',
    value: 'news',
    type: 'online'
  },
  {
    label: 'Blog',
    value: 'blog',
    type: 'online'
  },
  {
    label: 'Forum',
    value: 'forum',
    type: 'online'
  },
  {
    label: 'Social Networks',
    value: 'social-networks',
    type: 'social'
  }
] // local

export const priorities = [
  { label: "Level 1", value: 1 },
  { label: "Level 2", value: 2 },
  { label: "Level 3", value: 3 },
  { label: "Level 4 (out of focus)", value: 4 },
] // local

export const carmaOcrMediaSubtypes = ['newspaper', 'magazine']

export const carmaOcrProviderOptions = [
  { label: 'Carma OCR Arabic', value: 'carma_ocr_arabic' },
  { label: 'Carma OCR Asian', value: 'carma_ocr_asian' },
  { label: 'Carma OCR English', value: 'carma_ocr_english' },
  { label: 'Carma OCR French', value: 'carma_ocr_french' },
  { label: 'Carma OCR Hebrew', value: 'carma_ocr_hebrew' },
  { label: 'Carma OCR Iran', value: 'carma_ocr_iran' },
  { label: 'Carma OCR Portuguese', value: 'carma_ocr_portuguese' },
]

export const circulationTypes = [
  { label: "Hourly", value: 'hourly' }, // Broadcast only
  { label: "Daily", value: 'daily' },
  { label: "Weekly", value: 'weekly' },
  { label: "Biweekly", value: 'bi-weekly' },
  { label: "Fortnightly", value: 'fortnightly' },
  { label: "Monthly", value: 'monthly' },
  { label: "Bimonthly", value: 'bi-monthly' },
  { label: "Quarterly", value: 'quarterly' },
  { label: "Biannually", value: 'bi-annually' },
  { label: "Annually", value: 'annually' },
  { label: "Irregular", value: 'irregular' }
] // local: Corrected version

export const frequency = [
  { label: "Daily", value: 'daily' },
  { label: "Weekly", value: 'weekly' },
  { label: "Biweekly", value: 'bi-weekly' },
  { label: "Fortnightly", value: 'fortnightly' },
  { label: "Monthly", value: 'monthly' },
  { label: "Bimonthly", value: 'bi-monthly' },
  { label: "Quarterly", value: 'quarterly' },
  { label: "Biannually", value: 'bi-annually' },
  { label: "Annually", value: 'annually' },
  { label: "Irregular", value: 'irregular' }
] // local: Corrected version

export const scopeTypes = [
  { label: "National", value: 'national' },
  { label: "Regional", value: 'regional' },
  { label: "International", value: 'international' }
] // local: Corrected version

export const genres = [
  {
    label: 'News',
    value: 'news'
  },
  {
    label: 'Entertainment',
    value: 'entertainment'
  },
  {
    label: 'Travel',
    value: 'travel'
  },
  {
    label: 'Movie',
    value: 'movie'
  },
  {
    label: 'Music',
    value: 'music'
  },
  {
    label: 'Kids',
    value: 'kids'
  },
  {
    label: 'General',
    value: 'general'
  },
  {
    label: 'Religious',
    value: 'religious'
  },
  {
    label: 'Sports',
    value: 'sports'
  },
  {
    label: 'Documentary',
    value: 'documentary'
  },
  {
    label: 'Financial & Businness',
    value: 'financial and business information'
  }
]

export const currencies = ["RUB","AFN","EUR","ALL","GBP","GGP","DZD","AOA","XCD","ARS","AMD","AWG","SHP","AUD","AZN","BSD","BHD","BDT","BBD","BYN","BZD","XOF","BMD","BTN","INR","BOB","USD","BAM","BWP","BRL","BND","SGD","BGN","BIF","KHR","XAF","CAD","CVE","KYD","CLP","CNY","COP","KMF","CDF","CKD","NZD","CRC","HRK","CUP","ANG","CZK","DKK","DJF","DOP","EGP","ERN","SZL","ZAR","ETB","FKP","FOK","FJD","XPF","GMD","GEL","GHS","GIP","GTQ","GNF","GYD","HTG","HNL","HKD","HUF","ISK","IDR","IRR","IQD","IMP","ILS","JMD","JPY","JEP","JOD","KZT","KES","KID","KPW","KRW","KWD","KGS","LAK","LBP","LSL","LRD","LYD","CHF","MOP","MGA","MWK","MYR","MVR","MRU","MUR","MXN","MDL","MNT","MAD","MZN","MMK","NAD","NPR","NIO","NGN","MKD","TRY","NOK","OMR","PKR","PAB","PGK","PYG","PEN","PHP","PND","PLN","QAR","RON","RWF","WST","STN","SAR","RSD","SCR","SLL","SBD","SOS","SLS","SSP","LKR","SDG","SRD","SEK","SYP","TWD","TJS","TZS","THB","TOP","PRB","TTD","TND","TMT","TVD","UGX","UAH","AED","UYU","UZS","VUV","VES","VND","YER","ZMW","ZWB"]

export const paymentInterval = [
  {
    label: 'Weekly',
    value: 'Weekly'
  },
  {
    label: 'Monthly',
    value: 'Monthly'
  },
  {
    label: 'Quarterly',
    value: 'Quarterly'
  },
  {
    label: 'Biannually',
    value: 'Biannually'
  },
  {
    label: 'Annually',
    value: 'Annually'
  },
  {
    label: 'Every 52 Weeks',
    value: 'Every 52 Weeks'
  },
  {
    label: 'Every 4 Weeks',
    value: 'Every 4 Weeks'
  },
  {
    label: 'Every 6 Months',
    value: 'Every 6 Months'
  }
]

export const paywallTypes = [
  {
    value: 'Dynamic',
    label: 'Dynamic'
  },
  {
    value: 'Free Registration',
    label: 'Free Registration'
  },
  {
    value: 'Freemium',
    label: 'Freemium'
  },
  {
    value: 'Full',
    label: 'Full'
  },
  {
    value: 'No paywall',
    label: 'No paywall'
  },
  {
    value: 'QR Code Reader',
    label: 'QR Code Reader'
  },
  {
    value: 'Subscription Unavailable',
    label: 'Subscription Unavailable'
  }
]

export const paywallOptions = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
  {
    value: "N/A",
    label: "N/A",
  },
];



export const SOCIAL_PROVIDERS = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'X (Twitter)', value: 'twitter' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'TikTok', value: 'tiktok' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'Snapchat', value: 'snapchat' }
];

export const SOCIAL_PROVIDERS_MAP = SOCIAL_PROVIDERS.reduce((acc, provider) => {
  acc[provider.value] = provider.label;
  return acc;
}, {});

export const SOCIAL_PROVIDERS_LIST = SOCIAL_PROVIDERS.map(provider => provider.value);

export const TWITTER_OUTLET_NAME = "X (formerly Twitter)"

export const socialProviderIcon = (provider) => {
  let socialIcon = provider;
  switch (provider) {
    case 'gnip':
    case 'twitter':
    case 'x-twitter':
    case TWITTER_OUTLET_NAME.toLowerCase():
      socialIcon = 'twitter';
      break;
    case 'instagram':
    case 'ig':
    case 'ig_mention':
    case 'instagram_mention':
      socialIcon = 'instagram';
      break;
    case 'youtube':
    case 'yt':
    case 'yt_mention':
    case 'youtube_mention':
      socialIcon = 'youtube';
      break;
    case 'facebook':
    case 'fb':
    case 'fb_mention':
    case 'facebook_mention':
      socialIcon = 'facebook';
      break;
    case 'linkedin':
    case 'social-linkedin':
    case 'linkedin_mention':
      socialIcon = 'linkedin';
      break;
    case 'tiktok_mention':
      socialIcon = 'tiktok';
      break;
    case 'reddit':
    case 'reddit_mention':
    case 'social-reddit':
      socialIcon = 'reddit';
      break;
    case 'weibo':
    case 'weibo_mention':
      socialIcon = 'weibo';
      break;
    case 'wechat':
    case 'wechat_mention':
      socialIcon = 'wechat';
      break;
    case 'red':
    case 'red_mention':
      socialIcon = 'red';
      break;
    case 'douyin':
    case 'douyin_mention':
      socialIcon = 'douyin';
      break;
    default:
      socialIcon = provider;
      break;
  }
  return socialIcon;
};